import cs from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { useMemo } from 'react';
import { Button } from '@/DesignSystem/Component';
import type { IButtonColorType } from '@/DesignSystem/Model/DataModel';
import { LINKS } from '@/Module/Core/Constant';
import { formatPrice } from '@/Module/Core/Helper';
import { useAppSelector } from '@/Module/Store/Hook';
import { SubscriptionDescription } from '@/Module/Subscription/Component';
import type { ISubscriptionPlan } from '@/Module/Subscription/Model/DataModel';
const BOX_CLASS: Record<string, string> = {
  green: 'border-greenSix ',
  blue: 'border-blueSix ',
  pink: 'border-pinkSix ',
  orange: 'border-orangeSix '
};
const PRICE_COLOR: Record<string, string> = {
  green: 'before:bg-greenFive',
  blue: 'before:bg-blueFive',
  pink: 'before:bg-pinkFive',
  orange: 'before:bg-orangeFive'
};
const BUTTON_COLOR: Record<string, IButtonColorType> = {
  green: 'green',
  blue: 'primary',
  orange: 'orange',
  pink: 'pink'
};
interface ISubscriptionPlanProps extends ISubscriptionPlan {
  blank?: boolean;
}
const SubscriptionPlan: FC<ISubscriptionPlanProps> = ({
  subscriptionName,
  color,
  subscriptionDescription,
  id,
  price,
  duration,
  blank
}) => {
  const {
    originalPrice = 0,
    price: mainPrice = 0
  } = price ?? {};
  const isLoggedIn = useAppSelector(state => state.auth.isLoggedIn);
  const router = useRouter();
  const month = Math.round(duration! / 30);
  const title = useMemo(() => {
    return subscriptionName.split('_')[0];
  }, [subscriptionName]);
  const subtitle = useMemo(() => {
    return subscriptionName.split('_')[1];
  }, [subscriptionName]);
  return <div className={cs(BOX_CLASS[color], `relative max-w-full flex-1 bg-white p-4 sm:px-4 sm:py-6 flex flex-col  border-2 text-blackSeven`)} data-sentry-component="SubscriptionPlan" data-sentry-source-file="SubscriptionPlan.tsx">
      <span className={cs(`block mb-1 text-center text-xl font-extrabold `)}>{title}</span>
      {subtitle && <span className={cs(`block mb-2 text-center  font-extrabold `)}>{subtitle}</span>}

      {!!originalPrice && <div className={cs('relative mx-auto  w-fit text-center before:absolute before:top-[14px] before:h-[2px] before:w-full', PRICE_COLOR[color])}>
          <span className={cs(`text-lg font-extrabold `)}>{formatPrice(Math.round(originalPrice / month))}</span>
          <span className={cs(` font-extrabold `)}>تومان</span>
          <span className={cs(`text-sm font-extrabold text-blackFive`)}>/ ماه</span>
        </div>}

      <div className="mb-3 flex  items-center justify-center gap-2 text-center">
        <span className={cs(`text-xl font-extrabold `)}>{mainPrice ? formatPrice(Math.round(mainPrice / month)) : 0}</span>
        <span className={cs(`text-xl font-extrabold `)}>تومان</span>
        <span className={cs(`text-md font-extrabold text-blackFive`)}>/ ماه</span>
      </div>

      <ul className={cs(' transition-all duration-200 mb-2 sm:flex-1 h-auto flex-1')}>
        <SubscriptionDescription subscriptionDescription={subscriptionDescription} data-sentry-element="SubscriptionDescription" data-sentry-source-file="SubscriptionPlan.tsx" />
      </ul>

      {blank ? <Button href={isLoggedIn ? LINKS.SUBSCRIPTION.ITEM.replace('[id]', String(id)) : `${LINKS.AUTH.LOGIN}?redirectUrl=${encodeURI(router.asPath)}`} as={Link} radius="circle" className="w-full self-end" color={BUTTON_COLOR[color] ?? 'primary'} variant="shadow" target="_blank">
          خرید اشتراک
        </Button> : <Button href={isLoggedIn ? LINKS.SUBSCRIPTION.ITEM.replace('[id]', String(id)) : `${LINKS.AUTH.LOGIN}?redirectUrl=${encodeURI(router.asPath)}`} as={Link} radius="circle" className="w-full self-end" color={BUTTON_COLOR[color] ?? 'primary'} variant="shadow">
          خرید اشتراک
        </Button>}
      <div className="mt-3 flex  items-center justify-center gap-2 text-center">
        <span className={cs(`text-md  text-blackFive`)}>قیمت کل:</span>
        <span className={cs(`text-xl font-extrabold `)}>{mainPrice ? formatPrice(mainPrice) : 0}</span>
        <span className={cs(`text-md font-extrabold `)}>تومان</span>
      </div>
    </div>;
};
export default SubscriptionPlan;